<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2022-03-04 10:36:28
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-19 14:32:42
-->
<template>
  <el-container>
    <el-aside style="background:#ffffff;overflow:hidden" :width="aside_width" v-if="!isMobile">
      <el-button style='font-size:18px;padding-left:20px;' type="text" @click="showmenu" :icon='isCollapse?"el-icon-s-unfold":"el-icon-s-fold"'></el-button>
      <el-menu :unique-opened="true" :default-active="routepath" router :collapse="isCollapse">
        <el-submenu v-for="(item,index) in menulist" :index="item.menuid+''" :key="index" router style="text-align:left">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item-group v-for="(it,ind) in item.children" :index="it.menuid+''" :key="ind">
            <el-menu-item :index="'/'+section+'/'+it.controller+'/'+it.action" >{{ it.title }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      menulist: JSON.parse(sessionStorage.getItem("menulist")),
      isCollapse: sessionStorage.getItem('isCollapse')==1?true:false,
      section: sessionStorage.getItem('section'),
    }
  },
  methods: {
    showmenu() {
      if(this.isCollapse){
        this.isCollapse = false;
        sessionStorage.setItem('isCollapse',0);
      }else{
        this.isCollapse = true;
        sessionStorage.setItem('isCollapse',1);
      }
    }
  },
  computed: {
    ...mapState({
      navList: state => state.navBar.navList
    }),
    routepath() {
      return this.$route.path;
    },
    aside_width() {
      return this.isCollapse ? "50px" : "200px";
    }
  },
  created() {
    console.log(this.menulist)
  }
};
</script>
